module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_4.54a1b9c6.pdf";